import type { SortOption } from "~~/shared/types/common"

export const PRODUCT_SORT_OPTIONS: SortOption[] = [
  { label: "Sort by Recommended", value: "recommendationRank_asc", sortp: "recommendationRank,ASC" },
  { label: "Sort by Price (low to high)", value: "price_asc", sortp: "price,ASC" },
  { label: "Sort by Price (high to low)", value: "price_desc", sortp: "price,DESC" },
  { label: "Sort by Rating (low to high)", value: "averageRating_asc", sortp: "averageRating,ASC" },
  { label: "Sort by Rating (high to low)", value: "averageRating_desc", sortp: "averageRating,DESC" },
  { label: "Sort by Name", value: "name.keyword_asc", sortp: "name,ASC" }
]
